import React from 'react';
import { Field } from 'react-final-form';
import { Grid } from 'semantic-ui-react';
import { MdClose } from 'react-icons/md';

import ButtonLink from 'components/ButtonLink';
import ButtonIconWrapper from 'components/ButtonIconWrapper';
import { VirtualizedTableListColumn } from 'services/virtualizedTable/types';
import getValidateFunction from 'forms/utils/get-validate-function';

import VirtualizedTableColumnListItemWrapper from '../VirtualizedTableColumnListItemWrapper';
import getColumnTypeFieldProps from '../../utils/get-column-type-field-props';

interface Props {
    name: string;
    columnListColumns?: VirtualizedTableListColumn[];
    isEditForm?: boolean;
    disabled?: boolean;
    onClick: () => void;
}

export class VirtualizedTableColumnListItemComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const {
            name,
            columnListColumns,
            isEditForm,
            onClick,
            disabled = false
        } = this.props;

        if (!columnListColumns || !columnListColumns.length) {
            return null;
        }

        return (
            <VirtualizedTableColumnListItemWrapper
                left={
                    <Grid columns="equal" stackable>
                        <Grid.Row>
                            {columnListColumns.map(
                                (column: VirtualizedTableListColumn) => {
                                    const {
                                        value,
                                        type,
                                        disableUpdating,
                                        options,
                                        label
                                    } = column;

                                    return (
                                        <Grid.Column key={value}>
                                            <Field
                                                fluid
                                                name={`${name}.${value}`}
                                                label={label}
                                                placeholder={`${
                                                    options ? 'Add' : 'Enter'
                                                }`}
                                                subscription={{
                                                    value: true,
                                                    touched: true,
                                                    error: true
                                                }}
                                                validate={getValidateFunction(
                                                    column.validators
                                                )}
                                                disabled={
                                                    disabled ||
                                                    (isEditForm &&
                                                        disableUpdating)
                                                }
                                                {...(options
                                                    ? {
                                                          options
                                                      }
                                                    : {})}
                                                {...getColumnTypeFieldProps(
                                                    type
                                                )}
                                            />
                                        </Grid.Column>
                                    );
                                }
                            )}
                        </Grid.Row>
                    </Grid>
                }
                right={
                    <ButtonLink
                        buttonProps={{
                            type: 'button'
                        }}
                        onClick={onClick}
                    >
                        <ButtonIconWrapper noAdjacentText>
                            <MdClose
                                style={{
                                    fontSize: 22
                                }}
                            />
                        </ButtonIconWrapper>
                    </ButtonLink>
                }
            />
        );
    }
}

export default VirtualizedTableColumnListItemComponent;
